import styled from 'styled-components';

export const MainContainer = styled.div`
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const TreeContainer = styled.div`
    border-radius: 8px;
    border: solid 1px #e3e5e7;
    border: ${props => props.error ? "solid 1px #f10b3c" : "solid 1px #e3e5e7"};
    background-color: #ffffff;
    padding: 12px;
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const ErrorText = styled.div`
    color: #f10b3c;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    padding: 2px 16px;
`;